function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBackground = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 700 255",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M707.262-339.455c56.784 72.957 44.945 177.193 19.536 266.102-21.887 76.589-87.021 124.102-146.266 177.36-68.132 61.247-126.23 146.697-217.779 149.901-101.53 3.553-196.788-54.565-261.151-133.139C34.933 39.378-6.719-67.415 15.253-170.325c20.906-97.923 107.304-164.234 194.193-214.022 74.756-42.836 159.896-45.775 245.695-38.037 91.605 8.261 195.638 10.359 252.121 82.929Z",
    style: {
      fill: "#dfe5ff",
      fillOpacity: 0.3
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBackground);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/background.822b1ba26a2702e1785c72b811033986.svg";